<template>
  <el-dialog class="chooseServiceCss" width="842px" title="顾客签名" :visible.sync="show" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
    <div class="autograph-box">
      <canvas :id="'canvas'+key" class="newCanvas" @click.left="start" @click.right="start"></canvas>
      <div class="bottom">
        <span @click="empty">清空签名</span>
      </div>
    </div>

    <div class="canvasBtn">
      <el-button @click="skip">跳过</el-button>
      <el-button type="primary" :disabled="loading" @click="loading ? '' : obtain()">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import axios from '@/http/index';
import SignaturePad from 'signature_pad';
import { fetchPolice } from '../../api';

export default {
  props: {
    btnDisable: {
      type: Function,
      default: Function
    }
  },
  data() {
    return {
      signaturePad: '',
      status: 1,
      show: false,
      loading: true,
      key: window.sessionStorage.newKey
    };
  },
  watch: {
    show(val) {
      if (val) {
        setTimeout(() => {
          const canvas = document.querySelector(`#canvas${this.key}`);
          this.signaturePad = new SignaturePad(canvas);
          canvas.width = canvas.clientWidth;
          canvas.height = canvas.clientHeight;
          this.signaturePad.clear();
          this.signaturePad.off();
          this.signaturePad.on();
          // this.$forceUpdate();
        }, 300);
      } else {
        window.sessionStorage.newKey = this.key * 1 + 1;
        if (this.status == 2) return;
        this.$emit('getCanvas', '');
      }
    }
  },
  methods: {
    empty() {
      this.signaturePad.clear();
      this.loading = true;
    },
    start() {
      this.loading = false;
    },
    async obtain() {
      this.loading = true;
      // 获取图片的base64位地址
      const dataurl = this.signaturePad.toDataURL('image/png');
      // 下面是base64位地址转为文件流
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const suffix = mime.split('/')[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const file = new File([u8arr], `${'顾客签名'}.${suffix}`, {
        type: mime
      });
      // 获取上传策略
      let result = null;
      let keysList = [];
      result = await fetchPolice({}).then((res) => res);
      keysList = Object.keys(result.data);
      const uploadList = [];
      const formData = new FormData();
      keysList.forEach((key) => {
        formData.append(key, result.data[key]);
      });
      formData.append('key', result.data.dir + file.name);
      formData.append('file', file);
      uploadList.push(axios.post(result.data.host, formData).then((res) => res.data));
      const resList = await Promise.all(uploadList);
      const value = resList[0].data.fileDomain + resList[0].data.filename[0];
      this.status = 2;
      this.$emit('getCanvas', value);
      this.show = false;
      this.signaturePad.clear();
    },
    skip() {
      this.status = 2;
      this.$emit('getCanvas', '');
      this.show = false;
      this.signaturePad.clear();
    },
    handleClose() {
      this.show = false;
      this.signaturePad.clear();
      this.status = 2;
      this.btnDisable();
    }
  }
};
</script>

<style scoped>
.newCanvas {
  width: 780px;
  height: 410px;
  border-radius: 4px;
}
.canvasBtn {
  float: right;
  padding: 15px 0 12px 0;
}
.autograph-box{
   border: 1px solid #DFE6EC;
}
.autograph-box .bottom{
  border-top: 1px solid #DFE6EC;
  text-align: right;

}
.autograph-box .bottom span{
  height: 60px;
  line-height: 60px;
  display: inline-block;
  cursor: pointer;
  background: #FFF;
  color: #606266;
  text-align: center;
  padding: 0 30px;
  font-size: 14px;
  border-left: 1px solid #DFE6EC;
}

</style>
